import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 112,
	height: 113,
	viewBox: "0 0 112 113",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M59.5014 72.8334H52.5014V79.8334H59.5014V72.8334Z",
			fill: "#D72121"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M56 96.1667C77.9073 96.1667 95.6667 78.4073 95.6667 56.5C95.6667 34.5927 77.9073 16.8334 56 16.8334C34.0927 16.8334 16.3334 34.5927 16.3334 56.5C16.3334 78.4073 34.0927 96.1667 56 96.1667ZM102.667 56.5C102.667 82.2733 81.7733 103.167 56 103.167C30.2268 103.167 9.33337 82.2733 9.33337 56.5C9.33337 30.7268 30.2268 9.83337 56 9.83337C81.7733 9.83337 102.667 30.7268 102.667 56.5Z",
			fill: "#D72121"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M52.5 65.8334V33.1667H59.5V65.8334H52.5Z",
			fill: "#D72121"
		})
	]
});
export default SvgError;
